import { integrationByAccountIdQuery } from '@/entities/integrations/queries';
import { useAppQuery } from '@/shared/lib/useAppQuery';

export const useIntegrationsByAccountId = (accountId: string | undefined) => {
  const { data, isError, error, ...otherQueryParams } = useAppQuery({
    ...integrationByAccountIdQuery(accountId!),
    enabled: !!accountId,
  });

  return { data, isError, error, ...otherQueryParams };
};
